const leftColumnList = ({ setSelectedItem, setShowRightColumn, designStatus, isPublished }) => {
  // メニュー項目を選択 → 右カラム表示まで行う共通ハンドラ付きで生成する。
  const navItem = (id, name, extra = {}) => ({
    id,
    name,
    onClick: () => {
      setSelectedItem(id);
      setShowRightColumn(true);
    },
    ...extra,
  });

  // 非公開のときは「公開範囲とURL」以外のサイト編集メニューを隠す
  // （公開してからデザイン・テキスト等を編集する導線に揃える）。
  if (!isPublished) {
    return [
      { id: "mySite", name: "マイサイト", size: "section" },
      navItem("mySitePublic", "公開範囲とURL"),
    ];
  }

  return [
    { id: "mySite", name: "マイサイト", size: "section" },
    navItem("mySitePublic", "公開範囲とURL"),
    // status には実際に選択中の配置タイプ（フルスクリーン / バナー）を表示する。
    navItem("mySiteDesign", "サイトのデザイン", { status: designStatus }),
    navItem("mySiteState", "ステートメント"),
    navItem("mySiteWorks", "作品登録"),
    navItem("mySiteReviews", "レビュー掲載"),
    navItem("mySiteText", "プロフィールテキスト"),
    navItem("mySiteFooter", "フッターのリンク設定"),
  ];
};

export default leftColumnList;
